<template>
<div id="app" class="site container hfeed">
  <HeadNav selectedLanguage="en" page="privacy" />
  <SiteBreadcrumb />

  <div id="content" class="site-content">
    <article class="privacy-article">
      <section class="privacy-content">
        <header class="privacy-header">
          <h1>Privacy Policy</h1>
        </header>

        <p>
          At GBAppZe, we value your privacy and are committed to handling your personal information responsibly. This Privacy Policy outlines how we collect, use, and protect your data when you browse our website or interact with our GBWhatsApp-related resources.
        </p>

        <section class="section">
          <h2>Information We Collect</h2>
          <p>We may gather basic details such as your name, email address, and message content when you contact us. Non-personal data, such as browser type or device information, may also be collected to enhance site performance and usability.</p>
        </section>

        <section class="section">
          <h2>How We Use Your Information</h2>
          <p>Your data helps us:</p>
          <ul>
            <li>Improve our website and user experience;</li>
            <li>Respond to your inquiries effectively;</li>
            <li>Monitor site performance and resolve technical issues.</li>
          </ul>
          <p>We do <strong>not</strong> sell, trade, or share your personal data for commercial purposes.</p>
        </section>

        <section class="section">
          <h2>Cookies</h2>
          <p>We use cookies to improve navigation and analyze visitor interactions. You can disable cookies in your browser settings, but doing so might affect certain features of our site.</p>
        </section>

        <section class="section">
          <h2>Third-Party Links</h2>
          <p>Our website may link to other resources for reference. GBAppZe is <strong>not affiliated with WhatsApp Inc.</strong>, and we are <strong>not the developer of GBWhatsApp</strong> — we only share informational content. External sites have their own privacy practices, which we do not control.</p>
        </section>

        <section class="section">
          <h2>Data Protection</h2>
          <p>We implement standard security measures to protect stored data. While no online transmission is 100% secure, we strive to maintain the highest level of safety possible.</p>
        </section>

        <section class="section">
          <h2>Updates to This Policy</h2>
          <p>We may revise this Privacy Policy from time to time. Any updates will be reflected on this page.</p>
        </section>

        <section class="section">
          <h2>Contact</h2>
          <p>If you have any questions about how we handle your information, please contact us at <strong>support@gbappze.com</strong>.</p>
        </section>

      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Privacy',
  components: { HeadNav },
};
</script>

<style scoped>
.privacy-article {
  display: block;
}

.privacy-content {
  max-width: 900px;
  margin: 2rem auto;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
}

.privacy-header {
  text-align: center;
  margin-bottom: 24px;
}

.section {
  margin: 24px 0;
}

.section p {
  line-height: 1.7;
  color: #495057;
  font-size: 1.1em;
}

.section ul {
  line-height: 1.7;
  color: #495057;
  font-size: 1.1em;
  margin: 12px 0;
  padding-left: 20px;
}

.section ul li {
  margin: 8px 0;
}

@media (max-width: 768px) {
  .privacy-content {
    padding: 16px;
    margin: 1rem auto;
  }
}
</style>
